import React, { useState } from "react";
import { useSelector } from "react-redux";

import Modal from "../Modal";
import logo from "../../../../assets/images/logo.png";
import { isValidUrl } from "../../../../helpers/isValidUrl";
import { requestQuantityForExistingSku } from "../../../../services/sku";
import { successToast } from "../../../../helpers/toast";

const RequestQuantityModal = ({ sku, closeModal }) => {
  const selectedMechanic = useSelector((state) => state.mechanic);
  const salesAgent = useSelector((state) => state.auth);
  const { selectedCar } = useSelector((state) => state.car);
  const { voiceOrderId } = useSelector((state) => state.order);

  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState();
  const [requestQuantityLoading, setRequestQuantityLoading] = useState(false);

  const onSubmit = async (e) => {
    setRequestQuantityLoading(true);

    e.preventDefault();

    const formData = {
      quantity,
      price: Number(price),
      skuId: sku.id,
      mechanicId: selectedMechanic.id,
      salesAgentId: salesAgent.id,
      carId: selectedCar?.carDetails?.id,
      voiceOrderId,
    };

    try {
      await requestQuantityForExistingSku(formData);

      successToast("تم اضافه طلبك بنجاح");
      closeModal();
    } catch (error) {
      console.log(error);
    }

    setRequestQuantityLoading(false);
  };

  return (
    <Modal close={closeModal} classNames="lg:w-full sm:w-full top-4">
      <div className="flex flex-col lg:flex-row items-center gap-6">
        <div className="w-full lg:w-1/3 flex-shrink-0 lg:h-80 my-auto">
          <img
            src={
              isValidUrl(sku.imageList[0]?.imageUrl)
                ? sku.imageList[0]?.imageUrl
                : logo
            }
            alt={sku.commercialName}
            className="w-full h-full object-center object-contain"
          />
        </div>

        <form
          dir="rtl"
          autoComplete="off"
          className="flex flex-col items-center lg:items-start gap-7 border-light-gray rounded-lg w-full lg:w-2/3"
          onSubmit={onSubmit}
        >
          <div className="w-full flex flex-col">
            <div className="mb-4 py-6 px-4 border border-light-gray rounded-lg">
              <div className="mb-7">
                <p className="text-lg font-semibold text-gray-700">
                  {sku.skuBrand}
                </p>
                <p className="text-xl font-bold">{sku.commercialName}</p>
                <p className="text-lg font-bold text-pink-900">ID: {sku.id}</p>

                {voiceOrderId && (
                  <p className="text-lg font-bold text-pink-900">
                    Voice Order ID: {voiceOrderId}
                  </p>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="price">سعر البيع</label>
                <input
                  id="price"
                  type="number"
                  placeholder="من فضلك اضف سعر السوق"
                  value={price}
                  min={0}
                  onChange={(e) => setPrice(e.target.value)}
                  className="block w-full border border-light-gray mt-2 p-2 focus:border-dark-blue rounded"
                  required
                />
              </div>

              <div className="mb-6">
                <label htmlFor="quantity">الكمية المطلوبة</label>
                <input
                  id="quantity"
                  type="number"
                  min={1}
                  placeholder="الكمية"
                  value={quantity}
                  onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
                  className="block w-full border border-light-gray mt-2 p-2 focus:border-dark-blue rounded"
                  required
                />
              </div>

              {!selectedCar?.carDetails && (
                <p className="mt-0 text-xs font-bold text-red-500">
                  Should Select Car first
                </p>
              )}

              <div className="flex justify-between items-center gap-2 mt-4">
                <button
                  type="submit"
                  className="bg-dark-blue text-white p-2 rounded-lg w-1/2"
                  disabled={!selectedCar?.carDetails || requestQuantityLoading}
                >
                  إضافة
                </button>

                <button
                  type="button"
                  className="bg-gray-300 text-gray-700 p-2 rounded-lg w-1/2"
                  onClick={closeModal}
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default RequestQuantityModal;
